var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',{attrs:{"align":"start","justify":"start"}},[_c('v-col',{class:_vm.$vuetify.breakpoint.mdAndUp ? 'ml-0': 'px-0'},[_c('buttons-group',{attrs:{"items":_vm.items,"indexStep":_vm.index,"disabledAll":_vm.disabled},on:{"click":_vm.getIndex}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }